export enum MenuActionTypes {
    START_REQUEST = 'MENU_START_REQUEST',
    END_REQUEST = 'MENU_END_REQUEST',
    GET_MENU_SUCCESS = 'GET_MENU_SUCCESS',
    GET_MENU_ERROR = 'GET_MENU_ERROR'
}
